'use es6';

import MABPastExperiments from '../models/MABPastExperiments';
import { REQUESTED_MAB_PAST_EXPERIMENTS, REQUESTED_MAB_PAST_EXPERIMENTS_FAILED, REQUESTED_MAB_PAST_EXPERIMENTS_SUCCEEDED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new MABPastExperiments(), {
  type,
  payload
}) => {
  switch (type) {
    case REQUESTED_MAB_PAST_EXPERIMENTS:
      return state.set('status', RequestStatus.PENDING);
    case REQUESTED_MAB_PAST_EXPERIMENTS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    case REQUESTED_MAB_PAST_EXPERIMENTS_SUCCEEDED:
      return payload.mabPastExperiments;
    default:
      return state;
  }
});